import { isDesktop } from 'react-device-detect';
import { COMPONENTS } from '../../lib/constants';
let scale = isDesktop ? 1 : 2;
export const LogoView = {
	name: COMPONENTS.LOGO,
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'logo',
			type: 'Sprite',
			components: [
				{
					name: 'logo',
					type: 'Sprite',
					img: 'cosmo_logo',
					position: {
						x: -75,
						y: 10
					},
					scale: {
						x: scale,
						y: scale
					}
				}
			]
		}
	]
};
